import { State } from '@shure/shared/models';

import { StateFacade } from './state-facade.interface';

export abstract class StateFacadeBase<T> implements StateFacade<T> {
	protected readonly state = new State<T>(<never>null);
	public readonly state$ = this.state.state$;

	public snapshot(): T {
		return this.state.snapshot;
	}

	public updateState(update: Partial<T>): void {
		this.state.update(update);
	}
}
